document.addEventListener('DOMContentLoaded', function () {
    
    function checkDate(num) {
        const now = new Date();

        // 获取用户输入的起始和结束日期
        var startTime = $('.promotion-products-module').eq(num).find('.promotion-product-content').attr('start-time')
        var endTime = $('.promotion-products-module').eq(num).find('.promotion-product-content').attr('end-time')


        // 创建起始和结束日期对象
        const startDate = new Date(startTime);
        const endDate = new Date(endTime);
        endDate.setHours(23, 59, 59, 999); // 设置结束日期的时间为当天的最后一秒

        if (now < startDate) {
            $('.promotion-products-module').eq(num).find('.promotion-product-link').css('pointer-events', 'none')
            $('.promotion-products-module').eq(num).find('.promotion-product-btn').css('background-color', '#B4B4B4')
            $('.promotion-products-module').eq(num).find('.promotion-product-btn').text('Coming Soon')
            $('.promotion-products-module').eq(num).find('.left-content-time').css('display', 'block')
            $('.promotion-products-module').eq(num).find('.promotion-end-content').css('display', 'none')
        } else if (now > endDate) {
            $('.promotion-products-module').eq(num).find('.promotion-product-link').css('pointer-events', 'none')
            $('.promotion-products-module').eq(num).find('.promotion-product-btn').css('background-color', '#B4B4B4')
            $('.promotion-products-module').eq(num).find('.promotion-product-btn').text('Deal Ended')
            $('.promotion-products-module').eq(num).find('.left-content-time').css('display', 'none')
            $('.promotion-products-module').eq(num).find('.promotion-end-content').css('display', 'flex')
        } else {
            $('.promotion-products-module').eq(num).find('.promotion-product-link').css('pointer-events', 'auto')
            $('.promotion-products-module').eq(num).find('.promotion-product-btn').css('background-color', '#345701')
            $('.promotion-products-module').eq(num).find('.promotion-product-btn').text('Shop Now')
            $('.promotion-products-module').eq(num).find('.left-content-time').css('display', 'block')
            $('.promotion-products-module').eq(num).find('.promotion-end-content').css('display', 'none')
        }

        
    }

    // 每秒钟检查一次时间
    setInterval(function() {
        checkDate(0);
        checkDate(1);
    }, 1000)

    // 初始检查
    checkDate(0);
    checkDate(1);
});